import i18n from '../i18n';

const getLocalizedEnum = (prefix, montoto) => {
    if (!montoto)
        return "";

    return montoto.map(x => { x.title = i18n.t(`${prefix}.${x.code?.toLowerCase()}`); return x; })
}

export const bloodGroup = [
    { id: 1, title: "A" },
    { id: 2, title: "B" },
    { id: 3, title: "AB" },
    { id: 4, title: "O" }

]
export const bloodFactor = [
    { id: 1, title: "Rh+" },
    { id: 2, title: "Rh-" },
]

export const language = [
    { code: "es", title: "Español" },
    { code: "en", title: "Ingles" },
    { code: "pt", title: "Portugués" },
]

export const typeOptions = getLocalizedEnum("medicalRecords.typeOptions", [
    { id: 1, title: 'Consultorios Externos', code: "EXTERNAL" },
    { id: 2, title: 'Otros', code: "OTHER" },
    { id: 3, title: 'Investigación', code: "PROTOCOL" },
    { id: 4, title: 'Localización', code: "LOCALIZATION" }
    //{ id: 4, title: 'Proyectos', code: "PROJECT" }
])

export const visitTypesEnum = getLocalizedEnum("calendar.visitTypes", [
    { code: "PROTOCOL", title: 'Investigación' },
    { code: "PROJECT", title: 'Proyecto' },
    { code: "EXTERNAL", title: 'Consultorio Externo (Presencial)' },
    { code: "EXTERNAL_PHONE", title: 'Consultorio Externo (Teleconsulta)' },
    { code: "STUDIES", title: 'Estudios' },
    { code: "ESSENTIA", title: 'Consultorio Programa Essentia' },
    { code: "ORDER", title: 'Entrega de Receta' },
    { code: "OTHER", title: 'Otros' },
    { code: "PRESCREENING", title: 'PreScreening Investigación' },
    { code: "OVERSHIFT", title: 'Sobreturno' }
])

export const units = [
    { id: 1, title: 'mg' },
    { id: 2, title: 'mL' },
    { id: 3, title: 'ug' },
    { id: 4, title: 'g' },
    { id: 5, title: 'U' },
    { id: 6, title: 'Other' }
]

export const snomedExpressions = {
    Especialidad: "< 394733009",
    Trastorno: "< 64572001",
    MotivoConsulta: "< 71388002 OR < 243796009 OR < 272379006 OR < 404684003", // "< 404684003",// 
    Diagnostico: "< 243796009 OR < 272379006 OR < 404684003", //"< 404684003",// "< 243796009 OR < 272379006 OR < 404684003 MINUS (<< 49632008 OR 198863002 OR 198756005 OR 785872000 OR 785869007)",
    Hallazgos: "<< 404684003",
    Medicamentos: "781405001", // Producto, por ejemplo, Amoxidal, Ibupirac.
    Sustancia: "105590001", // Por ejemplo: Ibuprofeno, Amoxicilina. 
    Producto_O_Sustancia: "< 781405001 OR < 105590001",
    ViaAdministracion: "736479009",
    Procedimiento: "71388002",
    Laboratorio: "122869004", //   procedimiento de medición (procedimiento) 122869004
    Patologias: "< 64572001",
    Especialidades: "394658006",
    EspecialidadesMedicas: "< 394733009"
}

export const hcVisitStatus = {
    Draft: "Draft",
    Saved: "Saved",
    Published: "Published",
    AutoPublished: "AutoPublished"
}

export const visitStatus = {
    Started: 0,
    Completed: 1,
    Skipped: 2,
    Failed: 3,
    Changed: 4,
    AutoCompleted: 5
}

export const formStatus = {
    Initial: 0,
    Saved: 1,
    Draft: 2,
    Published: 9
}

export const visitTypes = {
    ProtocolVisit: 0,
    ExtraProtocolVisit: 1,
    Note: 2,
    EarlyCompletion: 3
}

export const visitTypesString = {
    ProtocolVisit: "ProtocolVisit",
    ExtraProtocolVisit: "ExtraProtocolVisit",
    Note: "Note",
    EarlyCompletion: "EarlyCompletion"
}

export const patientInProtocolStatus = {
    Screening: 0,
    Random: 1,
    Treatment: 2,
    FollowUp: 3,
    Failed: 4,
    LostToFollowUp: 5,
    WithoutDrugs: 6,
    Discontinuation: 7,
    EndParticipationInProtocol: 8,
    PreScreening: 9,
}

export const visitStage = {
    PreScreening: -1,
    Screening: 0,
    Random: 1,
    Treatment: 2,
    FollowUp: 3
}

export const visitTypeEnum = {
    OnSite: 0,
    Telephone: 1,
    Remote: 2
}

export const visitOffsetType = {
    Days: 0,
    Weeks: 1,
    Months: 2
}

export const noteEnum = {
    Initial: 0,
    Fixed: 1,
    Invalid: 2
}

export const formTypes = [
    { label: "NoSync", value: "NoSync" },
    { label: "Anthropometrics", value: "Anthropometrics" },
    { label: "Vitals", value: "Vitals" },
    { label: "AdverseEvents", value: "AdverseEvents" },
    { label: "Drugs", value: "Drugs" },
    { label: "Procedures", value: "Procedures" },
    { label: "LaboratoryResults", value: "LaboratoryResults" },
    { label: "Habits", value: "Habits" },
]

export const formTypeFields = [
    {
        type: "Anthropometrics",
        fields: [
            { value: "Weight", fieldType: "DecimalField" },
            { value: "Height", fieldType: "DecimalField" },
            { value: "Waist", fieldType: "DecimalField" },
            { value: "Sagittal", fieldType: "DecimalField" },
            { value: "Neck", fieldType: "DecimalField" },
            { value: "Others", fieldType: "SingleLineField" },
            { value: "Notes", fieldType: "MultiLineField" }
        ]
    },
    {
        type: "Vitals",
        fields: [
            { value: "BloodPressureHigh", fieldType: "IntegerField" },
            { value: "BloodPressureLow", fieldType: "IntegerField" },
            { value: "HeartRate", fieldType: "SingleLineField" },
            { value: "RespiratoryRate", fieldType: "SingleLineField" },
            { value: "TemperatureC", fieldType: "DecimalField" },
            { value: "OxygenSaturation", fieldType: "DecimalField" },
            { value: "Notes", fieldType: "MultiLineField" }
        ]
    },
    {
        type: "AdverseEvents",
        fields: [
            { value: "AdverseEvent", fieldType: "SnomedField" },
            { value: "Intensity", fieldType: "SelectAsyncField" },
            { value: "Serious", fieldType: "BooleanField" },
            { value: "Reported", fieldType: "BooleanField" },
            { value: "Relationwithdrug", fieldType: "SelectAsyncField" },
            { value: "Action", fieldType: "SelectAsyncField" },
            { value: "From", fieldType: "DateField" },
            { value: "To", fieldType: "DateField" },
            { value: "Notes", fieldType: "MultiLineField" }
        ]
    },
    {
        type: "Drugs",
        fields: [
            { value: "Drug", fieldType: "SnomedField" },
            { value: "RouteOfAdministration", fieldType: "SelectAsyncField" },
            { value: "Reason", fieldType: "AdverseEventsAsyncField" },
            { value: "Dose", fieldType: "IntegerField" },
            { value: "Unit", fieldType: "SelectAsyncField" },
            { value: "Frequency", fieldType: "SelectAsyncField" },
            { value: "From", fieldType: "DateField" },
            { value: "To", fieldType: "DateField" },
            { value: "Notes", fieldType: "MultiLineField" }
        ]
    },
    {
        type: "Procedures",
        fields: [
            { value: "Procedure", fieldType: "ProcedureSnomedField" },
            //{ value: "Procedure", fieldType: "SnomedField" },
            { value: "Reason", fieldType: "AdverseEventsAsyncField" },
            { value: "From", fieldType: "DateField" },
            { value: "To", fieldType: "DateField" },
            { value: "Notes", fieldType: "MultiLineField" }
        ]
    }
]

export const conditions = {
    observation: "problem-list-item",
    diagnosis: "encounter-diagnosis",
    adverseEvent: "adverse-event",
    personalHistory: "personal-history"
}

export const conceptType = {
    drugs: "Drugs",
    procedures: "Procedures",
    events: "Events",
    prescriptions: "Prescriptions",
    orders: "Orders",
    indications: "Patologias"
}

export const interopSystemEnum = {
    SnomedCT: 0,
    LOINC: 10,
    ICD10: 20,
    ICD11: 21,
    BR_CMED: 30,
    BR_CBHPM: 31,
    VADEMECUM: 41
}

export const prescriptionCreationMode = {
    Single: "0",
    MultipleDates: "1",
    Recurring: "2"
}

export const attachmentEntityType = {
    Startup: 1,
    Practitioner: 2,
    Hospital: 3,
    Protocols: 4,
    RegulatorySubmissions: 5,
}

export const attachmentCategories = {
    cda: 1,                         // CDA (Confidential Disclosure Agreement)
    feasibility: 2,                 // Feasibility
    communicationFile: 3,          // Documento de comunicación de la visita
    suitabilityFile: 4,            // Documentación del centro para aportar al Sponsor
    CElmFile: 5,                    // Aprobación CEIm
    CEIcFile: 6,                    // Aprobación CEIc
    AEMPSFile: 7,                   // Aprobación AEMPS
    trialInsuranceFile: 8,         // Seguro de Ensayo
    financialReportFile: 9,        // Memoria económica
    contractFile: 10,              // Contrato
    protocolFile: 11,              // Protocolo
    FDAFile: 12,                   // FDA
    labRangesFile: 13,             // Rangos de laboratorio
    delegationFile: 14,            // Delegación
    trainingLogFile: 15,           // Training log
    researchBrochureFile: 16,      // Investigator brochure
    confirmationLetterFile: 17,    // Confirmation Letter
    promoterConfirmationFile: 18,   // Documento de confirmación por parte del promotor
    CVs: 19,
    GCP: 20,
    startVisitFile: 21,
    centerActivation: 22,
    activationFile: 23,
    acceptanceFile: 24,
    flowchartSOA: 25,
    elegibilityForm: 26,
    recistTable: 27,
    newsletters: 28,
    acts: 29,
    recruitmentClosure: 30,
    closingVisit: 31,
    selectionVisitType: 32,
    //Team
    calibrationCertificateFile: 33,
    dangerousGoodFile: 34,
    iataFile: 35,
};
  
export const regulatorySubmissionStatuses =
{
    sponsorReceived: 1,
    committeePresented: 2,
    committeeReceivedCheck: 3,
    committeeChangesRequest: 4,
    committeeApproved: 5,
    sponsorSent: 6,
    implemented: 7,
};

export const regulatorySubmissionTypes =
{
    notification: 1,
    approval: 2,
};

export const securityEventTypes = getLocalizedEnum("security.securityAudit.eventTypes", [
    { id: 1, code: 'FailedLoginAttempt', title: 'Intento de acceso fallido' },
    { id: 2, code: 'UserLocked',         title: 'Usuario bloqueado' },
    { id: 3, code: 'PasswordChanged',    title: 'Cambio de contraseña' },
])

export const passwordChangeMethods = getLocalizedEnum("security.securityAudit.passwordChangeMethods", [
    { id: 1, code: 'UserChangePassword', title: 'El propio usuario' },
    { id: 2, code: 'ForgotPassword',     title: 'Olvidé mi contraseña' },
    { id: 3, code: 'AdminReset',         title: 'Reseteo por Admin' },
])